var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mail)?_c('div',{staticClass:"top-entity-component__parameter"},[_c('Icon24FillEmail',{staticClass:"top-entity-component__parameter-icon"}),_vm._v(" "),_c('LinkMail',{attrs:{"value":_vm.mail}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }